import PropTypes from "prop-types";

import WDBox from "../../../MaterialComponents/WDBox";

function DataTableBodyCell({ noBorder, align, children }) {
  return (
    <WDBox
      component="td"
      textAlign={align}
      py={0.5} /* Further reduced vertical padding */
      px={1.5} /* Further reduced horizontal padding */
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        height: "32px", /* Fixed compact height */
        maxHeight: "32px",
        lineHeight: 1, /* Even tighter line height */
        whiteSpace: "nowrap", /* Prevent text wrapping */
        overflow: "hidden", /* Hide overflow */
        textOverflow: "ellipsis", /* Add ellipsis for overflow */
      })}
    >
      <WDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </WDBox>
    </WDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
